import type { GikIconProps } from '@gik/ui/SvgIcon/GikIcons/index';
import { GikIconDefaultSize } from '@gik/ui/SvgIcon/GikIcons/index';
import React from 'react';

export const DragDoubleArrow = React.forwardRef(
  ({ size = GikIconDefaultSize, ...props }: GikIconProps, svgRef: React.Ref<SVGSVGElement>) => {
    return (
      <svg
        viewBox="0 0 10 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        ref={svgRef}
        {...props}
      >
        <defs>
          <path
            d="m15.711 2.707l3.936 3.936c.391.391.391 1.024 0 1.414-.391.391-1.024.391-1.414 0l-2.233-2.233v18.15l2.056-2.054c.391-.391 1.024-.391 1.414 0 .391.391.391 1.024 0 1.414l-3.76 3.76c-.391.391-1.024.391-1.414 0l-3.936-3.936c-.391-.391-.391-1.024 0-1.414.391-.391 1.024-.391 1.414 0l2.226 2.226v-18.13l-2.049 2.049c-.391.391-1.024.391-1.414 0-.391-.391-.391-1.024 0-1.414l3.76-3.76c.391-.391 1.024-.391 1.414 0"
            id="0"
            fillRule="nonzero"
            fill="currentColor"
          />
        </defs>
        <g fill="none" fillRule="evenodd">
          <use xlinkHref="#0" transform="translate(-10-2)" />
        </g>
      </svg>
    );
  }
);
